import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { TableComponent } from './table-component';
import { TableHeaderModule } from './table-header/table-header.module';

export const TableComponentModule: string = ng
    .module('table-component', [
        'ui.bootstrap',
        uiRouter,
        TableHeaderModule
    ])
    .component('tableComponent', TableComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/table-component/table-component.module.ts